/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type TenderPhases = 'RequestForInformation' | 'RequestForProposal';

export const TenderPhases = {
    RequestForInformation: 'RequestForInformation' as TenderPhases,
    RequestForProposal: 'RequestForProposal' as TenderPhases
};

